import React, { Fragment } from "react";
import { objectOf } from "prop-types";
import { Row, Col } from "react-bootstrap";

interface PhoneNumberRendererProps
{
    value: Phone[];
}

export default class PhoneNumberRenderer extends React.Component<PhoneNumberRendererProps>
{
    static formatPhoneNumber(phoneNumberString: any)
    {
        const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match)
        {
            const intlCode = (match[1] ? "+1 " : "");
            return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
        }

        return " - ";
    }

    render(): React.ReactNode
    {
        if (!this.props.value)
            return <b> - </b>;

        if (typeof this.props.value === "object")
        {
            if (this.props.value.length > 1)
            {
                return <Fragment>
                    {
                        this.props.value.map((phone: Phone, i: number) =>
                        {
                            return <Fragment key={i}>
                                <Row>
                                    <Col>
                                        <span>{phone.phoneTypeDescription}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>{PhoneNumberRenderer.formatPhoneNumber(phone.phoneNumber)}</b>
                                    </Col>
                                </Row>
                            </Fragment>;
                        })
                    }
                </Fragment>;
            }
            else if (this.props.value.length == 1)
            {
                return <b>{PhoneNumberRenderer.formatPhoneNumber(this.props.value[0].phoneNumber)}</b>;
            }
            else
            {
                return <b> - </b>;
            }
        }
        else
        {
            return <b>{PhoneNumberRenderer.formatPhoneNumber(this.props.value)}</b>;
        }
    }
}